import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { cloneDeep } from "lodash";
import { computed } from "vue";
import VCalendar from "primevue/calendar";


export default /*#__PURE__*/_defineComponent({
  __name: 'TimePicker',
  props: {
  modelValue: {
    type: String,
  },
},
  emits: ["update:modelValue"],
  setup(__props, { emit }) {

const props = __props;


// TODO: move to /assets and unit test
const HHMMtoDate = (value: string) => {
  const [hours, minutes] = value.split(":");
  const date = new Date();
  date.setHours(parseInt(hours));
  date.setMinutes(parseInt(minutes));
  return date;
};
// TODO: move to /assets and unit test
const dateToHHMM = (date: Date): string => {
  let hours = date.getHours();
  let minutes = date.getMinutes();
  let hoursString = hours.toString().padStart(2, "0");
  let minutesString = minutes.toString().padStart(2, "0");
  return `${hoursString}:${minutesString}`;
};

const time = computed({
  get: () =>
    props.modelValue ? HHMMtoDate(cloneDeep(props.modelValue)) : null,
  set: (value) => setTime(value!),
});
const setTime = (date: Date) => {
  const value = dateToHHMM(date);
  emit("update:modelValue", value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(VCalendar), {
      "time-only": "",
      "step-minute": 15,
      "model-value": _unref(time),
      onDateSelect: setTime
    }, {
      date: _withCtx((slotProps) => [
        _createTextVNode(_toDisplayString(slotProps) + " ok", 1)
      ]),
      _: 1
    }, 8, ["model-value"])
  ]))
}
}

})